import { Controller, useFormContext } from 'react-hook-form';

import { WrappedTextArea } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

import { useFormDataContext } from './FormDataContext';
import type { IForm } from './types';

export function WaresDescription() {
  const { t } = useAppTranslation(['common', 'demand']);
  const {
    control,
    formState: { errors },
  } = useFormContext<IForm>();

  const { serviceType } = useFormDataContext();
  const requiresWaresDescription = serviceType?.req_merchandise_description;

  if (!requiresWaresDescription) return null;
  return (
    <>
      <Controller
        control={control}
        rules={{
          required: t('msg.required_field'),
          minLength: {
            value: 20,
            message: t('demand:waresDescription.alertCheck'),
          },
          shouldUnregister: true,
        }}
        name="merchandise_description"
        render={({ field }) => (
          <WrappedTextArea
            {...field}
            isOnModal
            id="waresDescription"
            label={t('demand:waresDescription.label')}
            placeholder={t('demand:waresDescription.placeholder')}
            className="sm:col-span-2"
            value={field.value ?? ''}
            error={errors.merchandise_description?.message}
          />
        )}
      />
      <p
        className="text-xs font-medium text-gray-500 supports-[gap]:-mt-4 sm:col-span-2
          dark:text-gray-400"
      >
        {t('demand:waresDescription.description')}
      </p>
    </>
  );
}
